<script setup lang="ts">
import { ref } from 'vue'

import { useComputedAttrs, useEventsToValidate } from './helpers'
import type { DateInputProps } from './types'

const props = defineProps<DateInputProps>()
const emit = defineEmits(['change', 'blur', 'validate', 'invalid', 'validation'])
const input = defineModel<string>({ required: true })
const attrs = useComputedAttrs(props, 'date')
const baseEvents = useEventsToValidate(emit)
const inputRef = ref<HTMLInputElement | null>(null)

function onBlur() {
  emit('validation', inputRef.value?.validationMessage)
  emit('blur')
}

const events = { ...baseEvents, blur: onBlur }
</script>

<template>
  <input
    ref="inputRef"
    class="input"
    v-model="input"
    v-autofocus="props.autofocus"
    v-bind="attrs"
    type="date"
    :aria-required="props.required"
    :aria-invalid="props.invalid"
    v-on="events"
    :tabindex="props.tabindex"
  />
</template>
